import {connect} from "react-redux";
import Basket from "../../Components/TotalPrice/Basket";
import {bindActionCreators} from "redux";
import * as cartAction from '../../Redux/actions/carts'

const mapStateToProps = (state) => ({
    total:state.carts.items.reduce((total,product) => total + product.price , 0)
})
const mapDispatchToProps = (dispatch) => ({
   ...bindActionCreators(cartAction,dispatch)
})

export default connect(mapStateToProps,mapDispatchToProps)(Basket)
